import { IVoucherOrder } from '@epi-models/shared';

export const voucherOrder = (state): IVoucherOrder =>
  state.apiVoucherOrderDetails.voucherOrder;

export const isError = (state): boolean => state.apiVoucherOrderDetails.isError;
